import { httpGet, httpPost } from '../../../utils/api.utils';
import { USAGE_SPEND_CHART } from '../../../utils/constant.utils';
import {
    getCircuitData, getCircuitDataUsage, triggerIsPrimaryIndicator, showCircuitError,
    showUsageDetailsError, showSetAsPrimaryLoader, setIsFetching,
    setIsUsageDetailsFetching, setIsShowUsageDetails, setNoExchangeRate,
    setIsNoSubscription, setUsageMonthOptions, setUsageMonthSelected,
    setUsageSpendLineData, setUsageSpendBarData, setUsageSpendCurrMonthTotal } from '../../../constants/model-reducers/external/circuit-usage/circuit-usage.settings';

const initialState = {
    isShowUsageDetails: false,
    circuitData: null,
    circuitDataUsage: null,
    isPrimaryIndicator: false,
    isError: false,
    isUsageDetailsError: false,
    isShowSetPrimaryLoader: false,
    isFetching: true,
    isUsageDetailsFetching: false,
    noExchangeRate: true,
    isNoSubscription: true,
    usageMonthOptions: [],
    selectedUsageMonth: '',
    usageSpendLineData: [],
    usageSpendBarData: [],
    usageSpendCurrMonthTotal: 0
};

export const circuitUsageActions = {
    fetchCircuitData: (circuitId, financeAccountId) => async (dispatch) => {
        dispatch({
            type: setIsFetching,
            isFetching: true,
        });

        const data = {
            EmployeeId: parseInt(sessionStorage.EmployeeID, 10)
        };

        const subscriptionInfo = await httpGet(`external/usage/subscription/details/${circuitId}`);
        const usageData = await httpPost(`external/usage/subscription/${circuitId}`, data);
        const usageSpendData = await httpGet(`external/usage/subscription/getInventoryUsageSpend/${circuitId}/${financeAccountId}`);

        if (subscriptionInfo.ok === undefined) {

            hasExchangeRate(usageData, dispatch);
            loadUsageSpendData(usageData.Spend, USAGE_SPEND_CHART.BarChart, dispatch)
            dispatch({
                type: getCircuitData,
                circuitData: {
                    subscriptionInfo: subscriptionInfo,
                    usageData: usageData,
                    usageSpendData: usageSpendData
                },
            });

            dispatch({
                type: setIsFetching,
                isFetching: false,
            });
        } else {
            dispatch({
                type: showCircuitError,
                isError: true,
            });

            dispatch({
                type: setIsFetching,
                isFetching: false,
            });
        }
    },
    setAsPrimary: (circuit) => async (dispatch, getState) => {
        const userId = JSON.parse(sessionStorage.getItem('User')).Employee.UserId;
        const data = {
            circuitid: circuit.CircuitId,
            circuittypecategory: circuit.CircuitCategoryId,
            user: {
                employeeid: parseInt(circuit.UserId, 10),
                UserId: sessionStorage.UserId,
            },
        };

        dispatch({
            type: showSetAsPrimaryLoader,
            isShowSetPrimaryLoader: true,
        });

        const response = await httpPost(`external/circuit/primary/activate/${userId}`, data);

        if (response && response.ok === undefined) {
            dispatch({
                type: triggerIsPrimaryIndicator,
                isPrimaryIndicator: true,
            });
        }

        dispatch({
            type: showSetAsPrimaryLoader,
            isShowSetPrimaryLoader: false,
        });

        const subscriptionInfo = await httpGet(`external/usage/subscription/details/${circuit.CircuitId}`);
        const usageData = await httpPost(`external/usage/subscription/${circuit.CircuitId}`, data);
        const usageSpendData = await httpGet(`external/usage/subscription/getInventoryUsageSpend/${circuit.CircuitId}/${circuit.FinanceAccountId}`);
        if (subscriptionInfo.ok === undefined) {
            dispatch({
                type: getCircuitData,
                circuitData: {
                    subscriptionInfo: subscriptionInfo,
                    usageData: usageData,
                    usageSpendData: usageSpendData
                },
            });
        }
    },
    clearCircuitData: () => (dispatch) => {
        dispatch({
            type: getCircuitData,
            circuitData: initialState.circuitData,
        });

        dispatch({
            type: setIsShowUsageDetails,
            isFetching: initialState.isShowUsageDetails,
        });

        dispatch({
            type: triggerIsPrimaryIndicator,
            isPrimaryIndicator: false,
        });

        dispatch({
            type: showCircuitError,
            isError: false,
        });

        dispatch({
            type: showSetAsPrimaryLoader,
            isShowSetPrimaryLoader: false,
        });
    },
    fetchUsageSpendDetails: (circuitId) => async (dispatch, state) => {
        dispatch({
            type: setIsUsageDetailsFetching,
            isFetching: true,
        });

        const usageDetails = await httpGet(`external/usage/subscription/usageSpendBreakdown/${circuitId}`);

        if (usageDetails.ok === undefined) {
            hasExchangeRate(usageDetails, dispatch);

            dispatch({
                type: getCircuitDataUsage,
                circuitDataUsage: {
                    ...state().circuitUsage.circuitDataUsage,
                    usageDetails: usageDetails,
                },
            });

            dispatch({
                type: setIsUsageDetailsFetching,
                isFetching: false,
            });

            loadUsageMonthOptions(usageDetails.Usage, dispatch);
            loadUsageSpendData(usageDetails.Spend, USAGE_SPEND_CHART.LineChart, dispatch)
        } else {
            dispatch({
                type: showUsageDetailsError,
                isError: true,
            });

            dispatch({
                type: setIsUsageDetailsFetching,
                isFetching: false,
            });
        }
    },
    showUsageDetails: () => (dispatch, state) => {
        dispatch({
            type: setIsShowUsageDetails,
            data: !state().circuitUsage.isShowUsageDetails,
        });
    },
    noSubscriptionItems: () => (dispatch) => {
        dispatch({
            type: setIsNoSubscription,
            data: false,
        });
        dispatch({
            type: setIsFetching,
            data: false
        })
    },
    onUsageMonthSelect: (value) => async (dispatch, state) => {
        dispatch({
            type: setUsageMonthSelected,
            data: value,
        });
    }
};

function loadUsageMonthOptions(usageData, dispatch) {
    const dropItemValues = [];
    let ctr = 0;
    if (usageData !== undefined) {
        for (var y = usageData.length - 1; y >= 0; y--) {
            for (var m = usageData[y].UsageSpendMonths.length - 1; m >= 0; m--) {
                var usageMonthList = {
                    value: ctr,
                    label: usageData[y].UsageSpendMonths[m].Month + ' ' + usageData[y].Year
                }
                if (ctr === 0) {
                    dispatch({
                        type: setUsageMonthSelected,
                        data: usageData[y].UsageSpendMonths[m].Month + ' ' + usageData[y].Year,
                    });
                }
                dropItemValues.push(usageMonthList);
                ctr++;
            }
        }
        dispatch({
            type: setUsageMonthOptions,
            data: dropItemValues,
        });
    }
}

function loadUsageSpendData(usageData, barLineIndicator, dispatch) {
    const usageSpendLineDataValues = [];
    let ctr = 0;
    let usageSpendCurrMonthTotal = 0;
    if (usageData !== undefined) {
        for (var y = 0; y < usageData.length; y++) {
            for (var m = 0; m < usageData[y].UsageSpendMonths.length; m++) {
                var usageSpendDetails = {
                    Key: ctr,
                    Month: usageData[y].UsageSpendMonths[m].Month,
                    Year: usageData[y].Year,
                    Voice: usageData[y].UsageSpendMonths[m].Voice,
                    Messaging: usageData[y].UsageSpendMonths[m].Messaging,
                    Data: usageData[y].UsageSpendMonths[m].Data,
                    Other: usageData[y].UsageSpendMonths[m].Other,
                    Total: usageData[y].UsageSpendMonths[m].Total,
                    ExchangeRate: usageData[y].UsageSpendMonths[m].ExchangeRate,
                }
                usageSpendCurrMonthTotal = usageData[y].UsageSpendMonths[m].Total;
                usageSpendLineDataValues.push(usageSpendDetails);
                ctr++;
            }
        }
        if (parseInt(barLineIndicator) === parseInt(USAGE_SPEND_CHART.LineChart)) {
            dispatch({
                type: setUsageSpendLineData,
                data: usageSpendLineDataValues,
            });
        } else if (parseInt(barLineIndicator) === parseInt(USAGE_SPEND_CHART.BarChart)) {
            dispatch({
                type: setUsageSpendBarData,
                data: usageSpendLineDataValues,
            });
            dispatch({
                type: setUsageSpendCurrMonthTotal,
                data: usageSpendCurrMonthTotal,
            });
        }
    }
}

function hasExchangeRate(usageData, dispatch) {
    const exchangeRate = null;
    if (exchangeRate === null) {
        dispatch({
            type: setNoExchangeRate,
            data: true,
        });
    } else {
        dispatch({
            type: setNoExchangeRate,
            data: false,
        });
    }
}

export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case getCircuitData:
            return {
                ...state,
                circuitData: action.circuitData,
            };
        case getCircuitDataUsage:
            return {
                ...state,
                circuitDataUsage: action.circuitDataUsage,
            };
        case triggerIsPrimaryIndicator:
            return {
                ...state,
                isPrimaryIndicator: action.isPrimaryIndicator,
            };
        case showCircuitError:
            return {
                ...state,
                isError: action.isError,
            };
        case showUsageDetailsError:
            return {
                ...state,
                isUsageDetailsError: action.isError,
            };
        case showSetAsPrimaryLoader:
            return {
                ...state,
                isShowSetPrimaryLoader: action.isShowSetPrimaryLoader,
            };
        case setIsFetching:
            return {
                ...state,
                isFetching: action.isFetching,
            };
        case setIsUsageDetailsFetching:
            return {
                ...state,
                isUsageDetailsFetching: action.isFetching,
            };
        case setNoExchangeRate:
            return {
                ...state,
                noExchangeRate: action.data,
            };
        case setIsShowUsageDetails:
            return {
                ...state,
                isShowUsageDetails: action.data,
            };
        case setIsNoSubscription:
            return {
                ...state,
                isNoSubscription: action.noSubscription,
            };
        case setUsageMonthOptions:
            return {
                ...state,
                usageMonthOptions: action.data,
            };
        case setUsageMonthSelected:
            return {
                ...state,
                selectedUsageMonth: action.data,
            };
        case setUsageSpendLineData:
            return {
                ...state,
                usageSpendLineData: action.data,
            };
        case setUsageSpendBarData:
            return {
                ...state,
                usageSpendBarData: action.data,
            };
        case setUsageSpendCurrMonthTotal:
            return {
                ...state,
                usageSpendCurrMonthTotal: action.data,
            };
        default:
            return state;
    }
};
